<div class="rest-info-wrap">
  <button class="rest-info button button--th-ctrl" (click)="onOpen()">
    <div class="rest-info__body">
      <span class="h4" i18n="@@OurAddresses" *ngIf="(isUserChoose$ | async) !== true">Our addresses</span>
      <div class="rest-info__address h4" *ngIf="isUserChoose$ | async">
        <ng-container *ngIf="address$ | async as address; else restoInfo">
          <span title="{{ address }}">{{ address }}</span>
        </ng-container>
      </div>
    </div>
    <span class="rest-info__more">
      <i class="icomoon icomoon--caret-down"></i>
    </span>
  </button>
</div>

<div class="modal _mobile-full l-wrapper" *ngIf="isShowModal">
  <div  class="modal__overlay" (click)="onClose()"></div>
  <div class="modal__container">
    <div class="modal__content">
      <div class="modal__head l-wrapper">
        <div class="modal__title h1" i18n="@@SelectRestaurant">Select restaurant</div>
        <div class="modal__close">
          <button type="button" class="button-icon button-icon--th-ctrl" (click)="onClose()">
            <i class="icomoon icomoon--close"></i>
          </button>
        </div>
      </div>

      <div class="modal__body l-wrapper">
        <div class="resto-picker" *ngIf="outlets$ | async as outlets">
          <div class="resto-picker__item" *ngFor="let outlet of outlets">
            <button class="resto-picker__button button button--th-help" type="button"
              (click)="onChangeMenu(outlet.storeId)"
              [ngClass]="{'is-active': (activeOutletId$ | async) === outlet.storeId}"
            >
              <div class="resto-picker__title h4">{{ outlet.address }}</div>
              <div class="resto-picker__bottom h5" *ngIf="outletsSchedule && outletsSchedule[outlet.storeId] as schedule">
                <div class="resto-picker__time">
                  {{ schedule.open }} – {{ schedule.close }}
                </div>
                <div class="resto-picker__status" *ngIf="schedule.isOpen" i18n="@@Open">Open</div>
                <div class="resto-picker__status _error" *ngIf="!schedule.isOpen" i18n="@@Close">Close</div>
              </div>
              <span class="resto-picker__check">
                <i class="icomoon icomoon--check"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #restoInfo>
  <ng-container *ngIf="noOutlets$ | async; else noAddress">
    <p i18n="@@EmptyOutlesMessage">Restaurant is closed</p>
  </ng-container>
  <ng-template #noAddress>
    <p i18n="@@EmptyHeadAddressMessage">Address is empty</p>
  </ng-template>
</ng-template>
